
<SmartPopupCard :title="title">
  <template v-slot:content>
    <LineChart :data="chartData.data" :options="chartData.options" />
  </template>
</SmartPopupCard>
